import * as React from 'react';
import {
  checkFormHasError,
  getFormHelperText,
  handleBlurFormField,
  handleChangeFormField,
} from 'ui/forms/formHelpers';
import { useField } from 'formik';

import NumericField, { NumericFieldProps } from 'ui/NumericField';

interface FormNumericFieldProps extends NumericFieldProps {
  name: string;
}

/**
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
function FormNumericField(props: FormNumericFieldProps) {
  const { helperText, ...rest } = props;
  const [field, meta] = useField(rest.name);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    handleChangeFormField(field, event, rest.onChange);

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) =>
    handleBlurFormField(field, event, rest.onBlur);

  const hasError = checkFormHasError(meta);

  const helperTextValue = getFormHelperText(hasError, meta, helperText);

  return (
    <NumericField
      error={hasError}
      helperText={helperTextValue}
      {...field}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      {...(rest as any)}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
}

export default FormNumericField;
